module.exports = __webpack_public_path__ + "static/media/Truck-Card.d253c7ee.jpg";